import { render, staticRenderFns } from "./object.vue?vue&type=template&id=6fe8bdb6&"
import script from "./object.vue?vue&type=script&lang=js&"
export * from "./object.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports